import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }

import { ref, onMounted } from 'vue';
import moment from 'moment';
import { storage } from '@/utils/storage'
import DownloadBanner from '@/components/DownloadBanner.vue';
import GameSection from './components/GameSection.vue';
import HomeTop from './components/HomeTop.vue';
import FinanceBar from './components/FinanceBar.vue';
import SuspendIcon from '@/components/SuspendIcon.vue';
import { storeToRefs } from 'pinia';
import { useUserStore, usePopupStore, useSettingsStore } from '@/store'


export default {
  __name: 'index',
  setup(__props) {

const userStore = useUserStore();
const { uid } = storeToRefs(userStore);
const popupStore = usePopupStore();
const settingsStore = useSettingsStore()
const { showDownloadBanner } = storeToRefs(settingsStore);

const homeTopRef = ref();
const gameMenuFixed = ref(false);

onMounted(() => {
  let today = moment().format('YYYY-MM-DD');
  let lastNoticeDate = storage.get('lastNoticeDate');
  if (!lastNoticeDate || lastNoticeDate != today) {
    popupStore.set('showAgeVerifiction', true)
    storage.set('lastNoticeDate', today)
  }

  initTopObserver();
})

/**
 * 初始化观察器
 */
const initTopObserver = () => {
  const topObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 当条目出现在视口时，可以执行的操作
        gameMenuFixed.value = false;
      } else {
        gameMenuFixed.value = true;
      }
    })
  });

  topObserver.observe(homeTopRef.value.$el);
}

return (_ctx, _cache) => {
  const _component_HeaderBar = _resolveComponent("HeaderBar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DownloadBanner),
    _createVNode(_component_HeaderBar),
    _createElementVNode("div", {
      class: _normalizeClass(["home-page-scroll", { 'with-download-banner': _unref(showDownloadBanner), 'with-action-bar': !!_unref(uid) }])
    }, [
      _createElementVNode("div", null, [
        _createVNode(HomeTop, {
          ref_key: "homeTopRef",
          ref: homeTopRef
        }, null, 512)
      ]),
      (_unref(uid))
        ? (_openBlock(), _createBlock(FinanceBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(GameSection, { menuFixed: gameMenuFixed.value }, null, 8, ["menuFixed"])
    ], 2),
    _createVNode(SuspendIcon, {
      iconUrl: require('@/assets/img/common/service-btn.png')
    }, null, 8, ["iconUrl"])
  ]))
}
}

}